import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = ({primary = false, children, ...delegated}) => {
  return (
    <NTButton primary={primary} {...delegated}>{children}</NTButton>
  )
};

// Styles from main site
const NTButton = styled.button.attrs(props => ({
  className: `button ${props.primary ? 'button--primary' : 'button--ghost'}`
}))`

`;

Button.propTypes = {
  primary: PropTypes.bool,
  children: PropTypes.node,
};

export default Button;
